import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaUltraLogMenuRegistry = {
    personalize_nebulaUltraLog: {
        label: "Nebula Ultra Log",
        link: PAGE_URL.NEBULA_ULTRA_LOG_PAGE,
        key: PAGE_URL.NEBULA_ULTRA_LOG_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaUltraLogMenuRegistry;

